import { PageIndex, PageSizeAtom } from "../../state/page";

import { ConstrainDimensionsSelector } from "../../state/ui";
import { NumberOfPages } from "../../state/selectors";
import { StackCfKey } from "../../state/stack";
import { colors } from "@quickpoint.me/shared";
import styled from "styled-components";
import { useRecoilValue } from "recoil";

const InformationBar = styled.div<{
	$constrainDimensions: boolean;
	$baseFontSize: number;
}>`
  display: flex;
  opacity: .7;
  position: ${(props) => (props.$constrainDimensions ? "absolute" : "fixed")};
  bottom: 2px;
  left: 0;
  width: 100%;
  height: auto;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Gill Sans;
  background: ${colors.tufte.white}; 
  font-size: ${(props) => props.$baseFontSize * 2.4}px;
  justify-content: space-between;
  
`;

const StyledProgessBar = styled.div<{
	$percentComplete: string;
	$constrainDimensions: boolean;
	$isInLandscape: boolean;
}>`
background-color: ${colors.brand.purple};
width: ${(props) => props.$percentComplete}%;
position: ${(props) => (props.$constrainDimensions ? "absolute" : "fixed")};
height: ${(props) => (props.$isInLandscape ? "4px" : "2px")};
bottom: 0;
`;

const StoryName = styled.span`
margin-inline-start: .2rem;
text-wrap: no-wrap;
`;

const PageNumber = styled.span`
margin-inline-end: .2rem;
text-wrap: no-wrap;
    
`;

const InformationBarComponent = () => {
	const storyName = useRecoilValue(StackCfKey);
	const pageNumber = useRecoilValue(PageIndex);
	const numberOfPages = useRecoilValue(NumberOfPages);
	const constrainDimensions = useRecoilValue(ConstrainDimensionsSelector);
	const percentComplete = ((pageNumber / numberOfPages) * 100).toFixed(2);
	const baseFontSize = useRecoilValue(PageSizeAtom).baseFontSize;
	const isInLandscape = useRecoilValue(PageSizeAtom).landscape;
	return (
		<>
			<InformationBar
				$constrainDimensions={constrainDimensions}
				$baseFontSize={baseFontSize}
			>
				<StoryName>{storyName}</StoryName>
				<PageNumber>
					{pageNumber}/{numberOfPages}
				</PageNumber>
			</InformationBar>
			<StyledProgessBar
				$percentComplete={percentComplete}
				$constrainDimensions={constrainDimensions}
				$isInLandscape={isInLandscape}
			/>
		</>
	);
};

export default InformationBarComponent;
